const ErrorModal = ({ isOpen, onClose, errorMessage }) => {
    if (!isOpen) return null;

    return (
        <div className="app-modal">
            <div className="app-modal__backdrop" onClick={onClose} />

            <div className="app-modal__panel">
                <div className="app-modal__icon app-modal__icon--error">
                    <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v4m0 4h.01M10.29 3.86l-7.4 12.81A2 2 0 004.63 20h14.74a2 2 0 001.74-3.03l-7.37-12.8a2 2 0 00-3.45-.01z"
                        />
                    </svg>
                </div>

                <h3 className="app-modal__title">Action failed</h3>
                <p className="app-modal__text">
                    {errorMessage || "Something went wrong. Please try again."}
                </p>

                <div className="app-modal__actions">
                    <button
                        onClick={onClose}
                    className="btn-brand px-5 py-2.5 font-semibold"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;
